import React, { useState, useEffect } from 'react';
import NumericLabel from 'react-pretty-numbers';
import { Grid, Button, Tooltip } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import moment from 'moment';
import ApproveDialog from './ApproveDialog';
import TimelineModal from './TimelineModal';
import AddEditClaim from './AddEditClaim';
import RejectionDialog from './RejectionDialog';
import AssignUser from './AssignUser';
import ApproveUserModal from './ApproveUserModal';
import { AttachmentsRow, LabelValueCard } from '../../../shared_elements';
import { checkApiStatus, getLocalStorageInfo, permissionCheckFn } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { globalGetService } from '../../../utils/globalApiServices';
import { prettyNumberParamsDB } from '../../../constants';
import { titanAviInstance } from '../../../shared_elements/components';

const ClaimCard = ({ item, event, getShopVisitResponseBack, changeClaimStatus, getResponseBack, claimArr, mntEvents, assemblyType, rejectionFn, propsParams }) => {
  const [assignUserData, setAssignUserData] = useState({ modal: false, moduleName: "claims" })
  const [timetLineModal, setTimetLineModal] = useState(false)
  const [module, setModule] = useState([])
  const [moduleConstant, secModuleConstant] = useState([])
  const [showMore, setShowMore] = useState({});
  const toggleremarks = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  const userInfo = getLocalStorageInfo()
  const updatedItem = { ...item, approver_users: item?.approver_users?.map(ele => ele.id), forward_users: item?.forward_users?.map(ele => ele.id) }
  const mergedUsers = [...item?.approver_users || []];
  const uniqueUsers = mergedUsers.filter((user, index, self) =>
    index === self.findIndex(u => u.id === user.id)
  );
  const  uniqueByUserId = [...item?.claim_approval_users || []];
  const claimuser = uniqueByUserId?.filter(
    (item, index, self) =>
      index === self.findIndex(t => t.user.id === item.user.id)
  ); 

  const approvalStatusUser = uniqueUsers.map(a1 => {
    const match = claimuser.find(a2 => a2.user.id === a1.id);
    return { ...a1, approved_status: match ? match.approved_status : null };
  });
  const getEngineModuleConstant = () => {
    globalGetService(`console/get-constants/?constant_type=psrv_claim_module`)
      .then(response => {
        if (checkApiStatus(response)) {
          secModuleConstant(response?.data?.data)
        }
      })
  }
  const getModuleDescriptionApi = (params, query) => {
    globalGetService(`console/v2/asset/engine/${params}/llp/`, { for_reserve_account: query })
      .then(response => {
        if (checkApiStatus(response)) {
          const updatedResponse = response?.data?.data?.map(item => ({
            label: item,
            value: `${item?.toLowerCase()}_event`
          }));
          const activeModules = updatedResponse?.filter(option => ((event?.other_events && event?.other_events[option.value]) || (event && event[option.value])));
          const mergedArray = activeModules.map(item => {
            const match = moduleConstant?.find(ref => ref.label === item.label);
            return match
              ? { ...item, moduleValue: match.value, }
              : item;
          });
          setModule(mergedArray)
        }
      })
  }
  
  useEffect(() => {
    if (event?.asset_slug && event?.asset_type === 2) {
      getModuleDescriptionApi(event?.asset_slug, "module");
      getEngineModuleConstant()
    };
  }, [])
  const hasSomeApproved = titanAviInstance && claimuser?.some(user => user.approved_status.value === 2)
  const hasUserApproved = titanAviInstance && claimuser.filter(data => userInfo?.user?.id === data?.user?.id && data.approved_status.value ===2)?.length > 0
  return (
    <div className="content-info">
      <Tooltip title="View Status Timeline" arrow>
        <HistoryIcon className={
          ([1, 2].includes(item.status.value) &&
            permissionCheckFn({ secondaryKey: 'maintenance_claims', keyIndex: 'U' }) &&
            (!titanAviInstance || !hasSomeApproved))
            ? "timeline-claim"
            : "timeline-claim-r-10"
        } color="primary" onClick={() => setTimetLineModal({ modal: true })} />
      </Tooltip>
      <ApproveUserModal item={item} userArray={ titanAviInstance ? approvalStatusUser :  uniqueUsers} pageTitle="Claim" hasApproved={hasSomeApproved}/>
      <div style={{ display: 'flex', alignItems: "center", }}>
        {[1, 2].includes(item.status.value) && permissionCheckFn({ secondaryKey: 'maintenance_claims', keyIndex: 'U' }) &&
          (
            (!titanAviInstance || !hasSomeApproved) && (
              <span className="edit-sv">
                <AddEditClaim
                  getShopVisitResponseBack={getShopVisitResponseBack}
                  claimArr={claimArr}
                  event={event}
                  id={item.id}
                  claimData={item}
                  mntEvents={mntEvents}
                  getResponseBack={getResponseBack}
                  buttonText="Add Claim"
                  assemblyType="airframe"
                />
              </span>
            )
          )}
        <>
          {[1, 2].includes(item.status.value) && uniqueUsers?.some(item => item.id === userInfo?.user?.id) ?
            <table>
              <tbody>
                <tr>
                  <td>
                    {(() => {
                      const isClaimInReview = item.status.value === 2;
                      const claimText = isClaimInReview ? 'Claim In-Review' : 'Claim is Submitted';
                      if (!titanAviInstance) return claimText;
                      return !hasUserApproved
                        ? claimText
                        : 'Claim is Approved by You! The claim status will get updated once all the approvers approve the claim.';
                    })()}
                  </td>
                  {item.status.value === 1 && permissionCheckFn({ secondaryKey: 'maintenance_claims', keyIndex: 'U' }) ?
                    <td>
                      <Button
                        color="primary"
                        variant="outlined"
                        size='small'
                        onClick={() => {
                          changeClaimStatus({ status: item?.status?.value === 2 ? 3 : 2 })
                          trackActivity('Item Clicked', { page_title: 'Claim', item_type: item?.status?.value === 2 ? 'Approve' : 'Move to Review', status_type: item?.status?.label, assembly_type: this?.props?.assemblyType })
                        }}
                      >
                        Move to Review
                      </Button>
                    </td> : null
                  }
                  {permissionCheckFn({ secondaryKey: 'maintenance_claims', keyIndex: 'APR_REJ' }) &&
                    item.status.value === 2 &&
                    (!hasUserApproved || !titanAviInstance) && (
                      <>
                        <td> <ApproveDialog item={item} changeStatus={changeClaimStatus} approveFn={rejectionFn} pageTitle="Claims" /> </td>
                        <td> <RejectionDialog pageTitle="Claims" item={item} getResponseBack={getResponseBack} changeStatus={changeClaimStatus} assemblyType={assemblyType} rejectionFn={rejectionFn} /> </td>
                      </>
                    )}
                </tr>
              </tbody>
            </table>
            : null}
          {item?.status && [1, 2].includes(item.status.value) &&
            permissionCheckFn({ secondaryKey: 'maintenance_claims', keyIndex: 'U' }) &&
            (
              uniqueUsers == null ||
              (Array.isArray(uniqueUsers) &&
                (
                  uniqueUsers.length === 0 ||
                  uniqueUsers?.some(ele => ele.id == userInfo?.user?.id)
                )
              )
            ) ? (
            <>
              {item?.status && [0, 1, 2].includes(item.status.value) && uniqueUsers?.some(ele => ele.id == userInfo?.user?.id) ?
                ((!hasUserApproved) || !titanAviInstance) && <div className="divider"></div> : null}
              {(
                (item?.status?.value === 1 && titanAviInstance) ||
                !titanAviInstance ||
                (titanAviInstance && claimuser?.some( (data) => userInfo?.user?.id === data?.user?.id && data.approved_status.value === 1 ))
              ) && (
                  <div style={{ marginRight: "10px" }}>
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        setAssignUserData({
                          ...assignUserData,
                          modal: true,
                          moduleName: "claims",
                        })
                      }
                    >
                      Send For Approval
                    </Button>
                  </div>
                )}
            </>
          ) : null
          }
        </>
      </div>
      <Grid container spacing={3} style={{ margin: 0 }}>
        <LabelValueCard md={4} label='Submission Date' value={item.submission_date ? moment(item.submission_date).format('MMM DD, YYYY') : '--'} />
        {assemblyType !== "engine" || (assemblyType === "engine" && !item.shop_visit_events?.prsv && !item.shop_visit_events?.llp_replacement) ?
          <LabelValueCard md={4} label='Claim Amount' value={item.claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item.claim_amount}</NumericLabel> : '--'} /> : null
        }
        {(event?.asset_type == 2 && event?.prsv && module?.length > 0) ?
          module?.map((module, index) => {
            return <LabelValueCard md={4} label={module?.label} value={item?.prsv_claim_amount && item?.prsv_claim_amount[module.label] ?
              <NumericLabel params={prettyNumberParamsDB}>{item?.prsv_claim_amount[module.label]}</NumericLabel> : '--'} />
          })
          : null}
        {assemblyType === "engine" && item.shop_visit_events?.prsv && module?.length === 0 ?
          <LabelValueCard md={4} label='PRSV Claim Amount' value={item.claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item.claim_amount}</NumericLabel> : '--'} /> : null
        }
        {assemblyType === "engine" && item.shop_visit_events?.llp_replacement ?
          <LabelValueCard md={4} label='LLP Claim Amount  ' value={item.llp_claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item.llp_claim_amount}</NumericLabel> : '--'} /> : null
        }
        <LabelValueCard md={4} label='Claim Status' value={item.status.label} />
        {assemblyType !== "engine" || (assemblyType === "engine" && !item.shop_visit_events?.prsv && !item.shop_visit_events?.llp_replacement) ?
          <LabelValueCard md={4} label='Reserve Account' value={item.name ? item.name : '--'} /> : null
        }
        {assemblyType === "engine" && item.shop_visit_events?.prsv ?
          <LabelValueCard md={4} label='PRSV Reserve Account' value={item?.prsv_reserve_account?.name ? item?.prsv_reserve_account?.name : '--'} /> : null
        }
        {assemblyType === "engine" && item.shop_visit_events?.llp_replacement ?
          <LabelValueCard md={4} label='LLP Reserve Account' value={item?.llp_reserve_account?.name ? item?.llp_reserve_account?.name : '--'} /> : null
        }
        <LabelValueCard md={4} label='Claim Details' value={item.description ? item.description : '--'} />
        <LabelValueCard md={4} label='Period Extension Reason' value={item?.period_extend_reason && item?.period_extend_reason?.length > 200 ? (
          <div>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.period_extend_reason.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleremarks(item?.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.period_extend_reason.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleremarks(item?.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div>
            {item?.period_extend_reason ? <span dangerouslySetInnerHTML={{ __html: item?.period_extend_reason.replace(/\n/g, '<br />') }} /> : '--'}
          </div>
        )} />
        {
          item.status.label === "Rejected" ?
            <LabelValueCard md={4} label='Rejection Reason' value={item.reason_for_rejection ? item.reason_for_rejection : '--'} />
            : null
        }
        <LabelValueCard md={3} label='Attachments' value={item?.attachments?.length > 0 ? <AttachmentsRow attachmentsData={item?.attachments} /> : '--'} />
      </Grid>
      {assignUserData?.modal ? <AssignUser item={updatedItem} assignUserData={assignUserData} getResponseBack={getResponseBack} assetData={event} toggleModalFn={() => setAssignUserData({ modal: false, moduleName: "" })} /> : null}
      {timetLineModal ? <TimelineModal claimId={item?.id} propsParams={propsParams} pageTitle="Claim" assemblyType={assemblyType} item={item} modal={timetLineModal?.modal} toggleModalFn={() => setTimetLineModal({ modal: false })} /> : null}
    </div>
  )
}
export default ClaimCard